:host {
  display: flex;
  flex-direction: column;
  background-color: var(--message-robot-background-color);
  color: var(--message-robot-color);
}

.image-message {
  &__image {
    overflow: hidden;
    text-align: center;
    border-top-left-radius: 4px;
    border-top-right-radius: 20px;

    &--no-text {
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
  }

  &__text {
    display: flex;
    padding: 8px 16px;  
    background-color: var(--message-robot-background-color);
    color: var(--message-robot-color);
  }
}
